import { h } from 'preact'
import { placeMandater } from '../../../../lib/mandat-svg'
import {
  calculateSize,
  createSizeCalc,
  getCircle,
  getClippedLength,
  traceOutlines
} from '../../../../lib/mandat-svg/SvgHelper'
import { getTemplate } from './templates'
import { MandatTableItem, toEnkeltmandater } from '../mandater'
import { message } from '../../../../lib/intl/Message'

/* styles */
import styles from './MandatsamlingSvg.css'

export type SvgConfig = {
  rows: number
  radius: number
  spacing: number
  marginHorizontal: number
  marginVertical: number
}

type Props = {
  items: MandatTableItem[]
  config: SvgConfig
  title?: string
  partinavn?: boolean
}

export function MandatsamlingSvg(props: Props) {
  const { items, config, title, partinavn } = props
  const mandater = toEnkeltmandater(items)
  const template = getTemplate(config.rows)
  const table = placeMandater(template, mandater)
  const paths = traceOutlines(table, config)
  const length = getClippedLength(table, config)
  const size = calculateSize(config)
  const sizeRatio = size / config.radius
  const lengthRatio = length / config.radius

  return (
    <div
      style={{
        '--bar-length': createSizeCalc(config.radius, '100vw', lengthRatio),
        '--bar-size': createSizeCalc(config.radius, '100vw', sizeRatio)
      }}
      class={styles.mandatsamlingSvg}
    >
      <svg
        viewBox={`0 0 ${length} ${size}`}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          width: createSizeCalc(config.radius, '100vw', lengthRatio),
          maxWidth: createSizeCalc(config.radius, '800px', lengthRatio),
          height: createSizeCalc(config.radius, '100vw', sizeRatio),
          maxHeight: createSizeCalc(config.radius, '800px', sizeRatio)
        }}
      >
        {title && <title>{title}</title>}
        {paths.map(({ path, kortNavn, fargeSvak }) => {
          const item = items.find(item => item.kortNavn === kortNavn)
          if (!item) {
            return null
          }

          return (
            <path
              d={path}
              strokeWidth="0"
              style={{ fill: fargeSvak }}
              key={kortNavn}
              aria-label={message(
                'mandatsvg-gruppe',
                {
                  partinavn: item.navn,
                  antall: item.antall
                },
                { partinavn: partinavn && item.navn }
              )}
            />
          )
        })}
        {table.map((column, cIdx) => {
          return column.map((representant, rIdx) => {
            if (!representant) {
              return null
            }

            const { x, y, r } = getCircle(cIdx, rIdx, config)
            return (
              <circle
                r={r}
                cx={x}
                cy={y}
                key={`${cIdx} ${rIdx}`}
                style={{ fill: representant.farge }}
              />
            )
          })
        })}
        {
          <g>
            <line
              x1={length / 2}
              y1="0"
              x2={length / 2}
              y2={size / 2 - 11}
              strokeWidth={3}
              vectorEffect="non-scaling-stroke"
            />
            <line
              x1={length / 2}
              y1={size / 2 + 11}
              x2={length / 2}
              y2={size}
              strokeWidth={3}
              vectorEffect="non-scaling-stroke"
            />
          </g>
        }
      </svg>
    </div>
  )
}
